import React from 'react'
import { Link } from 'gatsby'

import { getProps } from '~/libs/es/navbar'

export default function NavbarItem({ to, text, external, deactivateNavbar }) {
    return !external
        ? <Link getProps={getProps} onClick={deactivateNavbar} key={to} to={to}>{text}</Link>
        : <a onClick={deactivateNavbar} key={to} href={to} className="navbar-item is-tab" target="_blank">{text}</a>
}